"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.10
//   protoc               v6.33.5
// source: protos/powernode-telem-svc.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowernodeTelemServiceClientImpl = exports.PowernodeTelemServiceServiceName = exports.GetCommandsResponse = exports.GetCommandsRequest = exports.CommandSetResult = exports.CommandSet = exports.Command = exports.EventBusCommand = exports.SendOCPPMessageCommand = exports.LegacyCommand = exports.SendAlertsResponse = exports.SendAlertsRequest = exports.Alert_TagsEntry = exports.Alert = exports.HealthCheckinResponse = exports.HealthCheckinRequest = exports.SendLogsResponse = exports.SendLogsRequest = exports.SendAllTelemetryMetadataResponse = exports.SendAllTelemetryMetadataRequest = exports.LogSource = exports.LogLine = exports.alertSeverityToJSON = exports.alertSeverityFromJSON = exports.AlertSeverity = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const timestamp_1 = require("../google/protobuf/timestamp");
const telem_metadata_1 = require("./telem-metadata");
exports.protobufPackage = "powernode";
/** Enumeration of alert severity levels. */
var AlertSeverity;
(function (AlertSeverity) {
    AlertSeverity[AlertSeverity["CRITICAL"] = 0] = "CRITICAL";
    AlertSeverity[AlertSeverity["HIGH"] = 1] = "HIGH";
    AlertSeverity[AlertSeverity["MODERATE"] = 2] = "MODERATE";
    AlertSeverity[AlertSeverity["LOW"] = 3] = "LOW";
    AlertSeverity[AlertSeverity["INFO"] = 4] = "INFO";
    AlertSeverity[AlertSeverity["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AlertSeverity = exports.AlertSeverity || (exports.AlertSeverity = {}));
function alertSeverityFromJSON(object) {
    switch (object) {
        case 0:
        case "CRITICAL":
            return AlertSeverity.CRITICAL;
        case 1:
        case "HIGH":
            return AlertSeverity.HIGH;
        case 2:
        case "MODERATE":
            return AlertSeverity.MODERATE;
        case 3:
        case "LOW":
            return AlertSeverity.LOW;
        case 4:
        case "INFO":
            return AlertSeverity.INFO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AlertSeverity.UNRECOGNIZED;
    }
}
exports.alertSeverityFromJSON = alertSeverityFromJSON;
function alertSeverityToJSON(object) {
    switch (object) {
        case AlertSeverity.CRITICAL:
            return "CRITICAL";
        case AlertSeverity.HIGH:
            return "HIGH";
        case AlertSeverity.MODERATE:
            return "MODERATE";
        case AlertSeverity.LOW:
            return "LOW";
        case AlertSeverity.INFO:
            return "INFO";
        case AlertSeverity.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.alertSeverityToJSON = alertSeverityToJSON;
function createBaseLogLine() {
    return { time: undefined, log: "" };
}
exports.LogLine = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.time), writer.uint32(10).fork()).join();
        }
        if (message.log !== "") {
            writer.uint32(18).string(message.log);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogLine();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.time = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.log = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
            log: isSet(object.log) ? globalThis.String(object.log) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.time !== undefined) {
            obj.time = message.time.toISOString();
        }
        if (message.log !== "") {
            obj.log = message.log;
        }
        return obj;
    },
    create(base) {
        return exports.LogLine.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLogLine();
        message.time = object.time ?? undefined;
        message.log = object.log ?? "";
        return message;
    },
};
function createBaseLogSource() {
    return { application: "", logLines: [] };
}
exports.LogSource = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.application !== "") {
            writer.uint32(10).string(message.application);
        }
        for (const v of message.logLines) {
            exports.LogLine.encode(v, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogSource();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.application = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.logLines.push(exports.LogLine.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            application: isSet(object.application)
                ? globalThis.String(object.application)
                : "",
            logLines: globalThis.Array.isArray(object?.logLines)
                ? object.logLines.map((e) => exports.LogLine.fromJSON(e))
                : globalThis.Array.isArray(object?.log_lines)
                    ? object.log_lines.map((e) => exports.LogLine.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.application !== "") {
            obj.application = message.application;
        }
        if (message.logLines?.length) {
            obj.logLines = message.logLines.map((e) => exports.LogLine.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.LogSource.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLogSource();
        message.application = object.application ?? "";
        message.logLines =
            object.logLines?.map((e) => exports.LogLine.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSendAllTelemetryMetadataRequest() {
    return { telemetryMetadata: undefined };
}
exports.SendAllTelemetryMetadataRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.telemetryMetadata !== undefined) {
            telem_metadata_1.AllTelemetryMetadata.encode(message.telemetryMetadata, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendAllTelemetryMetadataRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.telemetryMetadata = telem_metadata_1.AllTelemetryMetadata.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            telemetryMetadata: isSet(object.telemetryMetadata)
                ? telem_metadata_1.AllTelemetryMetadata.fromJSON(object.telemetryMetadata)
                : isSet(object.telemetry_metadata)
                    ? telem_metadata_1.AllTelemetryMetadata.fromJSON(object.telemetry_metadata)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.telemetryMetadata !== undefined) {
            obj.telemetryMetadata = telem_metadata_1.AllTelemetryMetadata.toJSON(message.telemetryMetadata);
        }
        return obj;
    },
    create(base) {
        return exports.SendAllTelemetryMetadataRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendAllTelemetryMetadataRequest();
        message.telemetryMetadata =
            object.telemetryMetadata !== undefined &&
                object.telemetryMetadata !== null
                ? telem_metadata_1.AllTelemetryMetadata.fromPartial(object.telemetryMetadata)
                : undefined;
        return message;
    },
};
function createBaseSendAllTelemetryMetadataResponse() {
    return {};
}
exports.SendAllTelemetryMetadataResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendAllTelemetryMetadataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SendAllTelemetryMetadataResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSendAllTelemetryMetadataResponse();
        return message;
    },
};
function createBaseSendLogsRequest() {
    return { logSources: [], pnid: 0 };
}
exports.SendLogsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.logSources) {
            exports.LogSource.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.pnid !== 0) {
            writer.uint32(16).int32(message.pnid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendLogsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.logSources.push(exports.LogSource.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            logSources: globalThis.Array.isArray(object?.logSources)
                ? object.logSources.map((e) => exports.LogSource.fromJSON(e))
                : globalThis.Array.isArray(object?.log_sources)
                    ? object.log_sources.map((e) => exports.LogSource.fromJSON(e))
                    : [],
            pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.logSources?.length) {
            obj.logSources = message.logSources.map((e) => exports.LogSource.toJSON(e));
        }
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        return obj;
    },
    create(base) {
        return exports.SendLogsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendLogsRequest();
        message.logSources =
            object.logSources?.map((e) => exports.LogSource.fromPartial(e)) || [];
        message.pnid = object.pnid ?? 0;
        return message;
    },
};
function createBaseSendLogsResponse() {
    return {};
}
exports.SendLogsResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendLogsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SendLogsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSendLogsResponse();
        return message;
    },
};
function createBaseHealthCheckinRequest() {
    return { pnid: 0 };
}
exports.HealthCheckinRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHealthCheckinRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        return obj;
    },
    create(base) {
        return exports.HealthCheckinRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHealthCheckinRequest();
        message.pnid = object.pnid ?? 0;
        return message;
    },
};
function createBaseHealthCheckinResponse() {
    return {};
}
exports.HealthCheckinResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHealthCheckinResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.HealthCheckinResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseHealthCheckinResponse();
        return message;
    },
};
function createBaseAlert() {
    return {
        timeUtc: undefined,
        severity: 0,
        team: "",
        source: "",
        title: "",
        description: "",
        tags: {},
        name: "",
    };
}
exports.Alert = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.timeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.timeUtc), writer.uint32(10).fork()).join();
        }
        if (message.severity !== 0) {
            writer.uint32(16).int32(message.severity);
        }
        if (message.team !== "") {
            writer.uint32(26).string(message.team);
        }
        if (message.source !== "") {
            writer.uint32(34).string(message.source);
        }
        if (message.title !== "") {
            writer.uint32(42).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(50).string(message.description);
        }
        globalThis.Object.entries(message.tags).forEach(([key, value]) => {
            exports.Alert_TagsEntry.encode({ key: key, value }, writer.uint32(58).fork()).join();
        });
        if (message.name !== "") {
            writer.uint32(66).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAlert();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.timeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.severity = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.team = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.source = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    const entry7 = exports.Alert_TagsEntry.decode(reader, reader.uint32());
                    if (entry7.value !== undefined) {
                        message.tags[entry7.key] = entry7.value;
                    }
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            timeUtc: isSet(object.timeUtc)
                ? fromJsonTimestamp(object.timeUtc)
                : isSet(object.time_utc)
                    ? fromJsonTimestamp(object.time_utc)
                    : undefined,
            severity: isSet(object.severity)
                ? alertSeverityFromJSON(object.severity)
                : 0,
            team: isSet(object.team) ? globalThis.String(object.team) : "",
            source: isSet(object.source) ? globalThis.String(object.source) : "",
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            description: isSet(object.description)
                ? globalThis.String(object.description)
                : "",
            tags: isObject(object.tags)
                ? globalThis.Object.entries(object.tags).reduce((acc, [key, value]) => {
                    acc[key] = globalThis.String(value);
                    return acc;
                }, {})
                : {},
            name: isSet(object.name) ? globalThis.String(object.name) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.timeUtc !== undefined) {
            obj.timeUtc = message.timeUtc.toISOString();
        }
        if (message.severity !== 0) {
            obj.severity = alertSeverityToJSON(message.severity);
        }
        if (message.team !== "") {
            obj.team = message.team;
        }
        if (message.source !== "") {
            obj.source = message.source;
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.tags) {
            const entries = globalThis.Object.entries(message.tags);
            if (entries.length > 0) {
                obj.tags = {};
                entries.forEach(([k, v]) => {
                    obj.tags[k] = v;
                });
            }
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        return obj;
    },
    create(base) {
        return exports.Alert.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAlert();
        message.timeUtc = object.timeUtc ?? undefined;
        message.severity = object.severity ?? 0;
        message.team = object.team ?? "";
        message.source = object.source ?? "";
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.tags = globalThis.Object.entries(object.tags ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        message.name = object.name ?? "";
        return message;
    },
};
function createBaseAlert_TagsEntry() {
    return { key: "", value: "" };
}
exports.Alert_TagsEntry = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAlert_TagsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.Alert_TagsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAlert_TagsEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseSendAlertsRequest() {
    return { pnid: 0, alerts: [] };
}
exports.SendAlertsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        for (const v of message.alerts) {
            exports.Alert.encode(v, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendAlertsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.alerts.push(exports.Alert.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0,
            alerts: globalThis.Array.isArray(object?.alerts)
                ? object.alerts.map((e) => exports.Alert.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        if (message.alerts?.length) {
            obj.alerts = message.alerts.map((e) => exports.Alert.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.SendAlertsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendAlertsRequest();
        message.pnid = object.pnid ?? 0;
        message.alerts = object.alerts?.map((e) => exports.Alert.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSendAlertsResponse() {
    return {};
}
exports.SendAlertsResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendAlertsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SendAlertsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSendAlertsResponse();
        return message;
    },
};
function createBaseLegacyCommand() {
    return { command: "" };
}
exports.LegacyCommand = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.command !== "") {
            writer.uint32(10).string(message.command);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLegacyCommand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.command = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            command: isSet(object.command) ? globalThis.String(object.command) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.command !== "") {
            obj.command = message.command;
        }
        return obj;
    },
    create(base) {
        return exports.LegacyCommand.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLegacyCommand();
        message.command = object.command ?? "";
        return message;
    },
};
function createBaseSendOCPPMessageCommand() {
    return { message: "", ocppId: "" };
}
exports.SendOCPPMessageCommand = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.ocppId !== "") {
            writer.uint32(18).string(message.ocppId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendOCPPMessageCommand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? globalThis.String(object.message) : "",
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== "") {
            obj.message = message.message;
        }
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        return obj;
    },
    create(base) {
        return exports.SendOCPPMessageCommand.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendOCPPMessageCommand();
        message.message = object.message ?? "";
        message.ocppId = object.ocppId ?? "";
        return message;
    },
};
function createBaseEventBusCommand() {
    return { topic: "", payload: "" };
}
exports.EventBusCommand = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.topic !== "") {
            writer.uint32(10).string(message.topic);
        }
        if (message.payload !== "") {
            writer.uint32(18).string(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventBusCommand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.topic = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.payload = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            topic: isSet(object.topic) ? globalThis.String(object.topic) : "",
            payload: isSet(object.payload) ? globalThis.String(object.payload) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.topic !== "") {
            obj.topic = message.topic;
        }
        if (message.payload !== "") {
            obj.payload = message.payload;
        }
        return obj;
    },
    create(base) {
        return exports.EventBusCommand.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEventBusCommand();
        message.topic = object.topic ?? "";
        message.payload = object.payload ?? "";
        return message;
    },
};
function createBaseCommand() {
    return {
        legacyCommand: undefined,
        sendOcppMessage: undefined,
        eventBusCommand: undefined,
    };
}
exports.Command = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.legacyCommand !== undefined) {
            exports.LegacyCommand.encode(message.legacyCommand, writer.uint32(10).fork()).join();
        }
        if (message.sendOcppMessage !== undefined) {
            exports.SendOCPPMessageCommand.encode(message.sendOcppMessage, writer.uint32(18).fork()).join();
        }
        if (message.eventBusCommand !== undefined) {
            exports.EventBusCommand.encode(message.eventBusCommand, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.legacyCommand = exports.LegacyCommand.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.sendOcppMessage = exports.SendOCPPMessageCommand.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.eventBusCommand = exports.EventBusCommand.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            legacyCommand: isSet(object.legacyCommand)
                ? exports.LegacyCommand.fromJSON(object.legacyCommand)
                : isSet(object.legacy_command)
                    ? exports.LegacyCommand.fromJSON(object.legacy_command)
                    : undefined,
            sendOcppMessage: isSet(object.sendOcppMessage)
                ? exports.SendOCPPMessageCommand.fromJSON(object.sendOcppMessage)
                : isSet(object.send_ocpp_message)
                    ? exports.SendOCPPMessageCommand.fromJSON(object.send_ocpp_message)
                    : undefined,
            eventBusCommand: isSet(object.eventBusCommand)
                ? exports.EventBusCommand.fromJSON(object.eventBusCommand)
                : isSet(object.event_bus_command)
                    ? exports.EventBusCommand.fromJSON(object.event_bus_command)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.legacyCommand !== undefined) {
            obj.legacyCommand = exports.LegacyCommand.toJSON(message.legacyCommand);
        }
        if (message.sendOcppMessage !== undefined) {
            obj.sendOcppMessage = exports.SendOCPPMessageCommand.toJSON(message.sendOcppMessage);
        }
        if (message.eventBusCommand !== undefined) {
            obj.eventBusCommand = exports.EventBusCommand.toJSON(message.eventBusCommand);
        }
        return obj;
    },
    create(base) {
        return exports.Command.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCommand();
        message.legacyCommand =
            object.legacyCommand !== undefined && object.legacyCommand !== null
                ? exports.LegacyCommand.fromPartial(object.legacyCommand)
                : undefined;
        message.sendOcppMessage =
            object.sendOcppMessage !== undefined && object.sendOcppMessage !== null
                ? exports.SendOCPPMessageCommand.fromPartial(object.sendOcppMessage)
                : undefined;
        message.eventBusCommand =
            object.eventBusCommand !== undefined && object.eventBusCommand !== null
                ? exports.EventBusCommand.fromPartial(object.eventBusCommand)
                : undefined;
        return message;
    },
};
function createBaseCommandSet() {
    return { id: 0, commands: [] };
}
exports.CommandSet = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        for (const v of message.commands) {
            exports.Command.encode(v, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommandSet();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.commands.push(exports.Command.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            commands: globalThis.Array.isArray(object?.commands)
                ? object.commands.map((e) => exports.Command.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.commands?.length) {
            obj.commands = message.commands.map((e) => exports.Command.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.CommandSet.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCommandSet();
        message.id = object.id ?? 0;
        message.commands =
            object.commands?.map((e) => exports.Command.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCommandSetResult() {
    return { id: 0, success: false };
}
exports.CommandSetResult = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.success !== false) {
            writer.uint32(16).bool(message.success);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommandSetResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.success = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            success: isSet(object.success)
                ? globalThis.Boolean(object.success)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.success !== false) {
            obj.success = message.success;
        }
        return obj;
    },
    create(base) {
        return exports.CommandSetResult.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCommandSetResult();
        message.id = object.id ?? 0;
        message.success = object.success ?? false;
        return message;
    },
};
function createBaseGetCommandsRequest() {
    return { pnid: undefined, ocppId: undefined, results: [] };
}
exports.GetCommandsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== undefined) {
            writer.uint32(8).int32(message.pnid);
        }
        if (message.ocppId !== undefined) {
            writer.uint32(26).string(message.ocppId);
        }
        for (const v of message.results) {
            exports.CommandSetResult.encode(v, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetCommandsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.results.push(exports.CommandSetResult.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : undefined,
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : undefined,
            results: globalThis.Array.isArray(object?.results)
                ? object.results.map((e) => exports.CommandSetResult.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== undefined) {
            obj.pnid = Math.round(message.pnid);
        }
        if (message.ocppId !== undefined) {
            obj.ocppId = message.ocppId;
        }
        if (message.results?.length) {
            obj.results = message.results.map((e) => exports.CommandSetResult.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetCommandsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCommandsRequest();
        message.pnid = object.pnid ?? undefined;
        message.ocppId = object.ocppId ?? undefined;
        message.results =
            object.results?.map((e) => exports.CommandSetResult.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetCommandsResponse() {
    return { commandSet: [] };
}
exports.GetCommandsResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.commandSet) {
            exports.CommandSet.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetCommandsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.commandSet.push(exports.CommandSet.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            commandSet: globalThis.Array.isArray(object?.commandSet)
                ? object.commandSet.map((e) => exports.CommandSet.fromJSON(e))
                : globalThis.Array.isArray(object?.command_set)
                    ? object.command_set.map((e) => exports.CommandSet.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.commandSet?.length) {
            obj.commandSet = message.commandSet.map((e) => exports.CommandSet.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetCommandsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCommandsResponse();
        message.commandSet =
            object.commandSet?.map((e) => exports.CommandSet.fromPartial(e)) || [];
        return message;
    },
};
exports.PowernodeTelemServiceServiceName = "powernode.PowernodeTelemService";
class PowernodeTelemServiceClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || exports.PowernodeTelemServiceServiceName;
        this.rpc = rpc;
        this.SendLogs = this.SendLogs.bind(this);
        this.HealthCheckin = this.HealthCheckin.bind(this);
        this.SendAlerts = this.SendAlerts.bind(this);
        this.SendAllTelemetryMetadata = this.SendAllTelemetryMetadata.bind(this);
        this.GetCommands = this.GetCommands.bind(this);
    }
    SendLogs(request) {
        const data = exports.SendLogsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SendLogs", data);
        return promise.then((data) => exports.SendLogsResponse.decode(new wire_1.BinaryReader(data)));
    }
    HealthCheckin(request) {
        const data = exports.HealthCheckinRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "HealthCheckin", data);
        return promise.then((data) => exports.HealthCheckinResponse.decode(new wire_1.BinaryReader(data)));
    }
    SendAlerts(request) {
        const data = exports.SendAlertsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SendAlerts", data);
        return promise.then((data) => exports.SendAlertsResponse.decode(new wire_1.BinaryReader(data)));
    }
    SendAllTelemetryMetadata(request) {
        const data = exports.SendAllTelemetryMetadataRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SendAllTelemetryMetadata", data);
        return promise.then((data) => exports.SendAllTelemetryMetadataResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetCommands(request) {
        const data = exports.GetCommandsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetCommands", data);
        return promise.then((data) => exports.GetCommandsResponse.decode(new wire_1.BinaryReader(data)));
    }
}
exports.PowernodeTelemServiceClientImpl = PowernodeTelemServiceClientImpl;
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
